import { ADDITIONAL_BACKGROUND_THEME_IMAGE_PREFIX_ID } from '@frontend/constants/templates-field-prefixes';

export const DISPLAY_BUILDER_LAYER_META_KEY = 'add_bk_img_display_builder_meta';
export const DISPLAY_BUILDER_LAYER_ROLE_REAR = 'rear';
export const DISPLAY_BUILDER_LAYER_ROLE_FOREGROUND = 'foreground';
export const DISPLAY_BUILDER_LAYER_ROLE_LOGO = 'logo';
export const DISPLAY_BUILDER_LAYER_ROLE_STORE_BACKGROUND = 'store';

export function createDisplayBuilderAssetKey() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `db-asset-${crypto.randomUUID()}`;
  }

  return `db-asset-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function normalizeDisplayBuilderLayerMeta(value) {
  return Array.isArray(value)
    ? value.map((item) => (item && typeof item === 'object' ? { ...item } : null))
    : [];
}

export function getAdditionalBackgroundIndex(objectOrId) {
  const id = String(objectOrId?.id || objectOrId || '');

  if (!id.startsWith(ADDITIONAL_BACKGROUND_THEME_IMAGE_PREFIX_ID)) {
    return null;
  }

  const index = Number(id.slice(ADDITIONAL_BACKGROUND_THEME_IMAGE_PREFIX_ID.length));

  return Number.isInteger(index) && index >= 0 ? index : null;
}

export function getDisplayBuilderLayerMetaForObject(metadata, objectOrId) {
  const index = getAdditionalBackgroundIndex(objectOrId);

  return index === null ? null : normalizeDisplayBuilderLayerMeta(metadata)[index] || null;
}

